export default "__VITE_ASSET__6QrKTuME__"